import React from 'react';
import { Button, Modal } from 'react-dsgov';
import { DiefCfemContext } from '../../../../../../../../../../../contexts/DiefCfemContext';
import { useNotificacao } from '../../../../../../../../../../../hooks/useNotificacao';
import { PaginasOutrosRegimes } from '../../../../../../../../../../../interfaces/IDadosOutrosRegimes';
import { IReceitaBruta } from '../../../../../../../../../../../interfaces/IReceitaBruta';
import { useBackEndRequests } from '../../../../../../../../../lib/backEndRequests';
import style from './listaReceitaBruta.module.scss';
import { useContext, useState } from 'react';
import { BrButton } from '@govbr-ds/react-components';
import ComponenteNCM from '../../../../../componenteNCM/componenteNCM';
import { ETipoOperacao } from '../../../../../../../../../../../enums/ETipoOperacao';
import CustomConfirmer from '../../../../../../../../../../../components/customConfirmer/customConfirmer';

export interface IListaReceitaBrutaProps {
  receitaBruta: IReceitaBruta | undefined;
  setBaseDeCalculo: React.Dispatch<React.SetStateAction<PaginasOutrosRegimes>>;
  setIsEdicao: React.Dispatch<React.SetStateAction<boolean>>;
  refetchLista: () => void;
  refetchDados: () => void;
}

function ListaReceitaBruta({
  receitaBruta,
  setBaseDeCalculo,
  setIsEdicao,
  refetchLista,
  refetchDados,
}: Readonly<IListaReceitaBrutaProps>) {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);

  const context = useContext(DiefCfemContext);

  const { deleteReceitaBruta } = useBackEndRequests();
  const mostrarNotificacao = useNotificacao();

  const editarReceitaBruta = () => {
    context?.setIdReceitaBruta(receitaBruta?.id ?? -1);
    setIsEdicao(true);
    setBaseDeCalculo('receitaBruta');
  };

  const deletarReceitaBruta = async () => {
    await deleteReceitaBruta(receitaBruta?.id ?? -1)
      .then(() => {
        refetchLista();
        refetchDados();
        setIsModalOpened(false);
      })
      .catch((err) => {
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao deletar Receita Bruta, tente novamente.',
          ...(err && { complementoSentryId: err }),
        });
      });
  };

  return (
    <>
      <Modal title='Excluir Receita Bruta (-) Tributos Incidentes Selecionada' useScrim modalOpened={isModalOpened}>
        <Modal.Body>Deseja mesmo deletar a receita bruta (-) tributos incidentes selecionada?</Modal.Body>
        <Modal.Footer justify-content='end'>
          <Button secondary small m={2} onClick={() => setIsModalOpened(false)}>
            Cancelar
          </Button>
          <CustomConfirmer asyncCall={() => deletarReceitaBruta()}>Confirmar</CustomConfirmer>
        </Modal.Footer>
      </Modal>
      <div
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title}>Receita Bruta (-) Tributos Incidentes</div>
        </div>
        <div className={style.rightContainer}>
          <BrButton
            data-testid='edit-button'
            circle
            size='small'
            icon='fas fa-edit fa-sm'
            onClick={() => editarReceitaBruta()}
          />
          <BrButton
            data-testid='delete-button'
            circle
            size='small'
            icon='fas fa-trash fa-sm'
            onClick={() => setIsModalOpened(true)}
          />
        </div>
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          <ComponenteNCM
            isEdicaoNcm={false}
            isReadOnly={true}
            ncmListaData={receitaBruta?.listaNcm}
            type={ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES}
          />
        </div>
      )}
    </>
  );
}

export default ListaReceitaBruta;
